import React, { useState, useEffect } from "react";
import Nav from "react-bootstrap/Nav";
import { Helmet } from "react-helmet-async";
import ListGroup from "react-bootstrap/ListGroup";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import SupportImage from "../../../../assets/img/Support-144px.svg";
import cancelButton from "../../../../assets/icons/Cancel-16px-Black-100.svg"
import "./settings-page.scss";

import {
    BrowserRouter as Router,
    Switch,
    Route,
    NavLink,
  } from "react-router-dom";
import PersonalizedNotification from "../settings-notification-page/settings-notifications";
import { GetCompanyByUserId } from "../../../../services/api/user-api";


const SettingsPage = (Props) => {
    const [receiveNewsletters] = useState(false);
    const [showPersonalizedNotification, setShowPersonalizedNotification] = useState(false);
    const [companySettings, setCompanySettings] = useState({});
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const isSelfServe = window["APP_SETTINGS"].REACT_APP_SELFSERVE_USER === "TRUE";

    useEffect(() => {
        GetCompanyByUserId()
        .then((res) => {
            console.log(res)
            if (res.status === 200) {
                setCompanySettings(res.data);
                if(res?.data?.HasPersonalizedEmailNotifications || res?.data?.HasPersonalizedPlatformNotifications){
                    setShowPersonalizedNotification(true);
                }
            }            
        })
        .catch((err) => {            
            console.log("Cannot get Company information : GetCompanyByUserId : ",err);
        }); 
    }, [])

  

    return (
        <div className="delete-modal-container">
            <Modal contentClassName="delete-modal-styles" className="delete-modal" show={showDeleteModal}>
                <Modal.Header>
                    <Container>
                        <Row>
                            <Col>
                                <h4 className="delete-modal-title">
                                    Delete Account
                                </h4>
                            </Col>
                            <Col>
                                <img alt="Close" className="close-button" onClick={() => setShowDeleteModal(false)} src={cancelButton} />
                            </Col>
                        </Row>
                    </Container>
                </Modal.Header>
                <Modal.Body className="modal-body-1">
                    <Container>
                        <Row>
                            <Col>
                                <div className="delete-modal-icon">
                                    <img src={SupportImage} alt={"Modal Icon"}/>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className="modal-text-container">
                                    <h3 className="modal-text">
                                        <p className="main-message">To delete your account, please write to us at
                                            &nbsp;<a className="email-link" href="mailto:support@triyo.io?subject=Account deletion request">support@triyo.io</a>
                                            &nbsp;and someone from our team will reach out to you with the next steps.
                                        </p>
                                    </h3>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Modal.Body>
            </Modal>
            <Switch>
                <Route exact path="/settings">
                    <Helmet>
                        <title>TRIYO · Settings Page</title>
                    </Helmet>
                    <div className="settings-page">
                        <h3 className="section-title">Settings</h3>
                        <ListGroup className="settings-panel dashboard-container-shadow">
                            <ListGroup.Item>
                            <Nav.Item>
                                <NavLink to="/profile/edit">
                                    <div className="setting-row">
                                        Edit Profile
                                    </div>
                                </NavLink>
                            </Nav.Item>
                            </ListGroup.Item>
                            <ListGroup.Item>
                                <NavLink to="/profile/edit">
                                    <div className="setting-row">
                                        Change Password
                                    </div>
                                </NavLink>
                            </ListGroup.Item>
                            {showPersonalizedNotification && <ListGroup.Item>
                                    <NavLink to="/settings/notification-settings">
                                        <div className="setting-row">
                                            Notification Settings
                                        </div>
                                    </NavLink>
                            </ListGroup.Item>}
                            {   isSelfServe &&
                                <ListGroup.Item>
                                    <Nav.Item>
                                        <a style={{ color: "#C11919" }} href="#delete-modal"
                                            onClick={() => setShowDeleteModal(true)}
                                            className="setting-row"
                                        >
                                            Delete Account
                                        </a>
                                    </Nav.Item>
                                </ListGroup.Item>
                            }
                            { receiveNewsletters &&
                                <>
                                <ListGroup.Item>
                                    <NavLink to="/settings/notification-settings">
                                        <div className="setting-row">
                                            Notification Settings
                                        </div>
                                    </NavLink>
                                </ListGroup.Item>
                                <ListGroup.Item>
                                    <div className="setting-row-inner">
                                        <Form>
                                            <div className="setting-checkbox-label">
                                                Receive Notifications
                                            </div>
                                            <Form.Check
                                                className="setting-row"
                                                type="switch"
                                            />
                                        </Form>
                                    </div>
                                </ListGroup.Item>
                                <ListGroup.Item>
                                <div className="setting-row-inner">
                                    <Form.Group>
                                        <div className="setting-checkbox-label">
                                            Receive Newsletters
                                        </div>
                                        <Form.Check
                                            className="setting-row"
                                            type="switch"
                                            id="newsletter"
                                        />
                                    </Form.Group>
                                </div>
                                </ListGroup.Item>
                                </>
                            }
                        </ListGroup>
                    </div>
                </Route>
                <Route exact path="/settings/notification-settings">
                        <Helmet>
                            <title>TRIYO · Personalized Notification Page</title>
                        </Helmet>
                        <PersonalizedNotification companySettings={companySettings}></PersonalizedNotification>
                </Route>
            </Switch>
        </div>
    );
}

export default SettingsPage;